<template>
  <div class="el-col-24">
    <h5 class="warp-title">快捷语管理</h5>
    <div class="search">
      <div class="clearfix">
        <div class="search-type">
          <span class="search-title">快捷语</span>
          <el-input size="small" v-model.trim="shortcutLanguage" placeholder="请输入快捷语关键词"></el-input>
        </div>
        <div class="search-type" v-if="querybtn.shortcut_management_query === 1">
          <el-button size="small" type="primary" @click="search()" :loading="isSearchLoading">查询</el-button>
        </div>
        <el-button v-if="querybtn.shortcut_management_add === 1" class="search-type" size="small" type="primary" @click="add()">新增记录</el-button>
        <el-upload
          class="search-type"
          accept=".xlsx, .xls"
          :action="importUrl"
          :show-file-list="false"
          multiple
          v-if="querybtn.shortcut_management_import === 1"
          :data="{token: token}"
          :before-upload="beforeAvatarUpload"
          :on-success="handleAvatarSuccess"
          name="shortcutLanguageFile">
          <el-button size="small">导入</el-button>
        </el-upload>
        <a style="font-size: 14px" v-if="querybtn.shortcut_management_download === 1" class="blue search-type" href="https://chindle-static.oss-cn-beijing.aliyuncs.com/data/other/%E5%AE%A2%E6%9C%8D%E5%BF%AB%E6%8D%B7%E8%AF%AD8703.xls?Expires=1594269929&OSSAccessKeyId=LTAIKC1D594RM2zh" download="download">下载导入模板</a>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      align="center"
      style="width: 100%">
      <el-table-column
        label="操作"
        align="center"
        width="90">
        <template slot-scope="scope">
          <span class="red cursor" v-if="querybtn.shortcut_management_delete === 1" @click="del(scope.row.id)">删除</span>
          <span class="blue cursor" v-if="querybtn.shortcut_management_edit === 1" @click="edit(scope.row.id)">编辑</span>
        </template>
      </el-table-column>
      <el-table-column
        label="快捷语"
        align="center">
        <template slot-scope="scope">
          {{scope.row.shortcutLanguage}}
        </template>
      </el-table-column>
      <el-table-column
        label="一级分类"
        align="center"
        width="200">
        <template slot-scope="scope">
          {{ scope.row.oneTypeName }}
        </template>
      </el-table-column>
      <el-table-column
        label="二级分类"
        align="center"
        width="200">
        <template slot-scope="scope">
          {{scope.row.twoTypeName}}
        </template>
      </el-table-column>
      <el-table-column
        label="添加人"
        align="center"
        width="200">
        <template slot-scope="scope">
          {{scope.row.addUserName}}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      align='right'
      class="mt20"
      background>
    </el-pagination>
    <el-dialog
      :title="title"
      :show-close="false"
      class="dialogs"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px">
      <el-form :model="fastForm" size="small" label-position="top" :rules="fastRule" ref="fastForm">
       <el-form-item label="一级分类" prop="oneTypeId">
          <el-select class="w200" v-model="fastForm.oneTypeId" placeholder="选择一级分类" @change="change()">
            <el-option v-for="(item, index) in oneTypeOption" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="twoTypeId">
          <el-select class="w200" v-model="fastForm.twoTypeId" size="small" placeholder="选择二级分类">
            <el-option v-for="(item, index) in twoTypeOption" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客服常用语" prop="shortcutLanguage">
          <el-input :rows="5" type="textarea" resize="none" v-model="fastForm.shortcutLanguage" placeholder="" maxlength="500"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitForm('fastForm')" :loading="isSubmitLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {customerShortcutLanguage, addCustomerShortcutLanguage, editCustomerShortcutLanguage, queryCustomerShortcutLanguageById, queryTypeList, delCustomerShortcutLanguage} from '../../api/fast/index'
import { queryButtonPermission } from '../../api/public/auth'
export default {
  name: 'Fast',
  created () {
    // 打印是否登录
    console.log(this.$store.state.Auth.sign)
    let data = {
      id: global.$sider
    }
    queryButtonPermission(data).then((info) => {
      if (info.data.resultCode === 0) {
        this.querybtn = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  },
  components: {
  },
  data () {
    return {
      isSubmitLoading: false,
      isSearchLoading: false,
      querybtn: {},
      id: null,
      token: this.$store.state.Auth.token,
      dialogVisible: false,
      shortcutLanguage: '',
      importUrl: this.$config.api_url + '/customerShortcutLanguage/importCustomerShortcutLanguage',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      oneTypeOption: [],
      twoTypeOption: [],
      type: null,
      title: '',
      fastForm: {
        oneTypeId: '',
        twoTypeId: '',
        shortcutLanguage: ''
      },
      fastRule: {
        oneTypeId: [
          { required: true, message: '请选择一级分类', trigger: 'change' }
        ],
        twoTypeId: [
          { required: true, message: '请选择二级分类', trigger: 'change' }
        ],
        shortcutLanguage: [
          { required: true, message: '请输入客服常用语', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    initdata () {
      let data = {
        shortcutLanguage: this.shortcutLanguage,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      this.isSearchLoading = true
      customerShortcutLanguage(data).then(info => {
        this.isSearchLoading = false
        let data = info.data
        if (info.data.resultCode === 0) {
          this.total = data.totalCount
          this.tableData = data.resultData
          let pageNum = Math.ceil(info.data.totalCount / this.pageSize)
          if (pageNum !== 0 && this.currentPage > pageNum) {
            this.currentPage = pageNum
            this.initdata()
          }
        } else {
          this.$message.error(info.data.resultMessage)
        }
      }).catch(() => {
        this.isSearchLoading = false
      })
    },
    currentChange (val) {
      this.currentPage = val
      this.initdata()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.initdata()
    },
    search () {
      this.initdata()
    },
    beforeAvatarUpload (file) { // 上传
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('请上传不超过10MB的文件!')
      }
      if (isLt10M) {
        this.loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
      }
      return isLt10M
    },
    handleAvatarSuccess (res, file) { // 上传课件回调
      this.loading.close()
      if (file.response.resultCode === 0) {
        this.$message({type: 'success', message: file.response.resultMessage})
        this.initdata()
      } else {
        this.$message.error(file.response.resultMessage)
      }
    },
    change () {
      let data = {
        pid: this.fastForm.oneTypeId
      }
      queryTypeList(data).then(info => {
        if (info.data.resultCode === 0) {
          this.fastForm.twoTypeId = ''
          this.twoTypeOption = info.data.resultData
        } else {
          this.$message.error(info.data.resultMessage)
        }
      })
    },
    del (id) {
      this.$confirm('是否删除这条快捷语', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        let data = {
          id: id
        }
        delCustomerShortcutLanguage(data).then((info) => {
          if (info.data.resultCode === 0) {
            this.initdata()
          } else {
            this.$message.error(info.data.resultMessage)
          }
        })
      })
    },
    add () {
      this.type = 1
      this.title = '新增'
      this.dialogVisible = true
      this.fastForm = {
        oneTypeId: '',
        twoTypeId: '',
        shortcutLanguage: ''
      }
    },
    edit (id) {
      this.id = id
      this.type = 2
      this.title = '编辑'
      let data = {
        id: id
      }
      queryCustomerShortcutLanguageById(data).then(ref => {
        if (ref.data.resultCode === 0) {
          this.fastForm = {
            oneTypeId: ref.data.resultData.oneType,
            twoTypeId: ref.data.resultData.twoType,
            shortcutLanguage: ref.data.resultData.shortcutLanguage
          }
          let datas = {
            pid: this.fastForm.oneTypeId
          }
          queryTypeList(datas).then(info => {
            if (info.data.resultCode === 0) {
              this.twoTypeOption = info.data.resultData
              this.dialogVisible = true
            } else {
              this.$message.error(info.data.resultMessage)
            }
          })
        } else {
          this.$message.error(ref.data.resultMessage)
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isSubmitLoading = true
          if (this.type === 1) {
            let data = {
              oneTypeId: this.fastForm.oneTypeId,
              twoTypeId: this.fastForm.twoTypeId,
              shortcutLanguage: this.fastForm.shortcutLanguage
            }
            addCustomerShortcutLanguage(data).then(info => {
              this.isSubmitLoading = false
              if (info.data.resultCode === 0) {
                this.dialogVisible = false
                this.initdata()
              } else {
                this.$message.error(info.data.resultMessage)
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
          } else {
            let data = {
              id: this.id,
              oneTypeId: this.fastForm.oneTypeId,
              twoTypeId: this.fastForm.twoTypeId,
              shortcutLanguage: this.fastForm.shortcutLanguage
            }
            editCustomerShortcutLanguage(data).then(info => {
              this.isSubmitLoading = false
              if (info.data.resultCode === 0) {
                this.dialogVisible = false
                this.initdata()
              } else {
                this.$message.error(info.data.resultMessage)
              }
            }).catch(() => {
              this.isSubmitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  },
  mounted () {
    queryTypeList().then(info => {
      if (info.data.resultCode === 0) {
        this.oneTypeOption = info.data.resultData
      } else {
        this.$message.error(info.data.resultMessage)
      }
    })
  }
}
</script>
<style lang="less" scoped>
.search{
  a{
    line-height: 32px;
  }
}
.el-tabs{
  margin-top: 20px;
}
.el-button + .el-button{
  margin-left: 0;
}
.con-data{
  max-height: 500px;
  overflow-y: auto;
}
.w200{
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/Fast/Index.vue